export default {
      id: "book-open-usage",
      viewBox: "0 0 24 24",
      url: "/dist/svg/" + "sprite.svg#book-open-usage",
      toString: function () {
        return this.url;
      }
    }